import "../../../App.css"
import CardColorBlock from "../../../components/cards/CardColorBlock/CardColorBlock";
import HighlightText from "../../../components/texts/HighlightText/HighlightText";
import Title from "../../../components/common/Title/Title";
import SEO from "../../../components/common/SEO/SEO";
import OptimizedImage from "../../../components/common/OptimizedImage/OptimizedImage";
import { useTranslation, Trans } from "react-i18next";

export default function Consultancy() {
    const { t } = useTranslation(["consultancy"]);

    const seo = t("seo", { returnObjects: true }) || {};
    const hero = t("hero", { returnObjects: true }) || {};
    const cards = t("cards", { returnObjects: true }) || {};
    const sections = t("sections", { returnObjects: true }) || {};

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                url="https://www.aivhy.com/solutions/consultancy"
                image="https://www.aivhy.com/images/logos/LOGO_AIVHY.webp"
            />
            <div className="main-container">
                <main className="head-content">
                    <div className="column-content-container height-container">
                        <Title text={hero.title} size={["4rem", "3rem", "2rem"]} level="h1" />
                        <HighlightText
                            text={hero.tagline}
                            size={["1.4rem", "1.2rem", "1rem"]} 
                            padding={["50px", "30px 24px", "20px"]}
                            fontWeight="500"
                            alignItems="flex-start"
                        />
                        <p className="paragraph-content">
                            <Trans
                                i18nKey="hero.body"
                                ns="consultancy"
                                components={[
                                    <a className="text-link" href="/expertise/industrial4-0" />, 
                                    <a className="text-link" href="/expertise/iiot" />
                                ]}
                            />
                        </p>
                    </div>
                    <div className="cards-container">
                        <CardColorBlock
                            image={"/images/icons/digi_brain.svg"}
                            iconStyle={{ fontSize: "70px", color: "white" }}
                            color={"var(--color-orange)"}
                            title={cards.expert_advice?.title}
                            text={cards.expert_advice?.body}
                        />
                        <CardColorBlock
                            iconClassName="fas fa-comments"
                            iconStyle={{ fontSize: "70px", color: "white" }}
                            color={"var(--color-blue)"}
                            title={cards.consultancy?.title}
                            text={cards.consultancy?.body}
                        />
                        <CardColorBlock
                            iconClassName="fas fa-user-edit"
                            iconStyle={{ fontSize: "70px", color: "white" }}
                            color={"var(--color-blue)"}
                            title={cards.peer_review?.title}
                            text={cards.peer_review?.body}
                        />
                        <CardColorBlock
                            iconClassName="fas fa-hands-helping"
                            iconStyle={{ fontSize: "70px", color: "white" }}
                            color={"var(--color-blue)"}
                            title={cards.sparring_partner?.title}
                            text={cards.sparring_partner?.body}
                        />
                    </div>
                </main>

                <section className="page-content-container">
                    <div>
                        <Title text={sections.successful?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                        <p className="paragraph-content">{sections.successful?.body}</p>
                    </div>
                    <div className="row-content-container reverse-column" style={{ alignItems: "center" }}>
                        <OptimizedImage 
                            src="/images/industries/machine.webp" 
                            className="machine-mask" 
                            alt="Machine"
                        />
                        <div>
                            <Title text={sections.state_of_the_art?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <p className="paragraph-content">{sections.state_of_the_art?.body1}</p>
                                <p className="paragraph-content">{sections.state_of_the_art?.body2}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row-content-container">
                        <div>
                            <Title text={sections.we_are_always_close?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                            <p className="paragraph-content">{sections.we_are_always_close?.body}</p>
                        </div>
                        <div>
                            <Title text={sections.realization?.title} size={["2rem", "1.8rem", "1.5rem"]}/>
                            <p className="paragraph-content">
                                <Trans
                                    i18nKey="sections.realization.body"
                                    ns="consultancy"
                                    components={[<a className="text-link" href="/solutions/implementation" />]}
                                />
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}